<template>
  <!-- c-screen-wrapper -->
  <div class="p-3" style="background-color: #f0f0f0;">
    <div class="row row-stretch is-margin-bottom">
      <div class="col-7 mb-3 mb-lg-0">
        <div class="c-board-box">
          <div class="c-board-title">
            <b-spinner small v-if="loading"></b-spinner>
            <img v-else src="/img/callio.svg" class="float-left" />
            <h1 v-if="department">Thi đua {{ department.name }} tháng {{ currentMonth }}</h1>
          </div>
        </div>
      </div>
      <div class="col-5">
        <div class="c-board-box">
          <div class="c-best-sales" v-if="bestSellerLastMonth && users.find(u => u._id === bestSellerLastMonth._id)">
            <div class="c-best-sales__content">
              <h2>Best seller tháng {{ lastMonth }}: <span class="text-pink">{{users.find(u => u._id ===
                bestSellerLastMonth._id).name}}</span></h2>
              <p>ĐẠT <span class="text-pink">{{ bestSellerLastMonth.total | numFormat }}đ</span></p>
            </div>
            <div class="c-best-sales__img">
              <figure>
                <img v-if="users.find(u => u._id === bestSellerLastMonth._id).avatar"
                  :src="users.find(u => u._id === bestSellerLastMonth._id).avatar" alt="avatar" @error="imgDefault" />
                <img v-else src="/img/default-avatar.png" alt="avatar" />
              </figure>
            </div>
          </div>
        </div><!-- c-board-box -->
      </div>
    </div>
    <div class="row row-stretch is-margin-bottom">
      <div class="col-4 mb-3 mb-lg-0">
        <div class="c-board-box">
          <div class="c-board-box__title text-center">Tổng doanh thu tháng {{ currentMonth }}</div>
          <div class="c-board-box__content">
            <apexchart :height="height" :options="chart1Options" :series="chart1Data"></apexchart>
          </div>
        </div>
      </div>
      <div class="col-8">
        <div class="c-board-box">
          <!--          <div class="row">-->
          <!--            <div class="col-md mb-3 mb-lg-0">-->
          <div class="c-board-box__title text-center">Doanh thu theo tuần tháng {{ currentMonth }}</div>
          <div class="c-board-box__content">
            <apexchart :height="height" :options="chart2Options" :series="chart2Data"></apexchart>
          </div>
          <!--            </div>-->
          <!--            <div class="col-6">-->
          <!--              <div class="c-board-box__title text-center">Mức độ hoàn thành KPI tháng {{currentMonth}}</div>-->
          <!--              <div class="c-board-box__content">-->
          <!--                <apexchart :height="height" :options="chart3Options" :series="chart3Data"></apexchart>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div><!-- c-board-box -->
      </div><!-- col -->
    </div>
    <div class="row row-stretch is-margin-bottom" v-if="data">
      <div class="col-4 mb-3 mb-lg-0">
        <div class="c-board-box bg-violet">
          <div class="c-board-box">
            <div class="c-board-box__title text-center text-uppercase text-pink">Top 3 Best Sales tháng
              {{ currentMonth }}
            </div>
            <div class="c-board-box__content">
              <div class="c-board-table table-responsive">
                <table class="table">
                  <tbody>
                    <tr v-if="data[data.length - 1] && users.find(u => u._id === data[data.length - 1]._id)">
                      <td class="text-center">1</td>
                      <td class="text-center">
                        <figure class="c-board-table__avatar c-image-border">
                          <img v-if="users.find(u => u._id === data[data.length - 1]._id).avatar"
                            :src="users.find(u => u._id === data[data.length - 1]._id).avatar" alt="avatar"
                            @error="imgDefault" />
                          <img v-else src="/img/default-avatar.png" alt="avatar" />
                        </figure>
                      </td>
                      <td><b class="c-rainbow-text" style="font-size: 30px">{{users.find(u => u._id ===
                        data[data.length - 1]._id).name}}</b>
                      </td>
                      <td class="text-right"><b class="text-pink">{{ data[data.length - 1].total | numFormat }}đ</b>
                      </td>
                    </tr>
                    <tr v-if="data[data.length - 2] && users.find(u => u._id === data[data.length - 2]._id)">
                      <td class="text-center">2</td>
                      <td class="text-center">
                        <figure class="c-board-table__avatar">
                          <img v-if="users.find(u => u._id === data[data.length - 2]._id).avatar"
                            :src="users.find(u => u._id === data[data.length - 2]._id).avatar" alt="avatar"
                            @error="imgDefault" />
                          <img v-else src="/img/default-avatar.png" alt="avatar" />
                        </figure>
                      </td>
                      <td><b class="text-violet" style="font-size: 25px">{{users.find(u => u._id === data[data.length -
                        2]._id).name}}</b>
                      </td>
                      <td class="text-right"><b class="text-pink">{{ data[data.length - 2].total | numFormat }}đ</b>
                      </td>
                    </tr>
                    <tr v-if="data[data.length - 3] && users.find(u => u._id === data[data.length - 3]._id)">
                      <td class="text-center">3</td>
                      <td class="text-center">
                        <figure class="c-board-table__avatar" style="border-color: black">
                          <img v-if="users.find(u => u._id === data[data.length - 3]._id).avatar"
                            :src="users.find(u => u._id === data[data.length - 3]._id).avatar" alt="avatar"
                            @error="imgDefault" />
                          <img v-else src="/img/default-avatar.png" alt="avatar" />
                        </figure>
                      </td>
                      <td><b class="" style="font-size: 20px">{{users.find(u => u._id === data[data.length -
                        3]._id).name}}</b>
                      </td>
                      <td class="text-right"><b class="text-pink">{{ data[data.length - 3].total | numFormat }}đ</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div><!-- c-board-box -->
        </div><!-- c-board-box -->
      </div><!-- col -->

      <div class="col-8">
        <div class="c-board-box">
          <div class="c-board-box__title text-center">Bảng thi đua Sales tháng {{ currentMonth }}</div>
          <div class="c-board-box__content">
            <apexchart :height="height" :options="chart5Options" :series="chart5Data"></apexchart>
            <div class="small text-center">Tính theo doanh thu KPI: không gồm gia hạn của khách đã dùng trên 12 tháng</div>
          </div>
        </div>
      </div>

      <!--      <div class="col-4">-->
      <!--        <div class="c-board-box">-->
      <!--          <div class="c-board-box__title text-center">Bảng thi đua Sales quý {{currentQuarter}}</div>-->
      <!--          <div class="c-board-box__content">-->
      <!--            <apexchart :height="height" :options="chart6Options" :series="chart6Data"></apexchart>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="row row-stretch is-margin-bottom">
      <div class="col-12">
        <div class="c-board-box bg-violet">
          <div class="row row-stretch is-margin-bottom">
            <div class="col-4 mb-3 mb-lg-0">
              <div class="c-board-box">
                <div class="c-tranfer-list">
                  <label>Giao dịch</label>
                  <ul v-if="planOrders && planOrders.length">
                    <li v-for="planOrder in planOrders" :key="planOrder._id">
                      <span style="color: #3e0079">{{ planOrder.sales ? planOrder.sales.name : 'Khách' }}</span>
                      {{ $t(planOrder.type) }} <b class="text-pink">{{ planOrder.total | numFormat }}<sup>đ</sup></b>
                      lúc {{ planOrder.confirmTime | moment('DD/MM/YYYY HH:mm:ss') }}
                    </li>
                  </ul>
                </div>
              </div><!-- c-board-box -->
            </div><!-- col -->
            <div class="col-8">
              <div class="c-board-box">
                <div v-if="!rannkingDay" class="text-center" style="font-size: 25px; color: #3e0079">Chưa phát sinh đơn
                  đơn hàng gói dịch vụ trong ngày {{ Date.now() | moment('DD/MM/YYYY') }}
                </div>
                <div v-else class="c-board-ranking row">
                  <div class="c-board-ranking__left col-4">
                    <div class="c-best-sales">
                      <div class="c-best-sales__content">
                        <h3>{{ rannkingDay && rannkingDay.sales ? rannkingDay.sales.name : 'Khách' }}</h3>
                      </div>
                      <div class="c-best-sales__img">
                        <figure
                          v-if="rannkingDay && rannkingDay.sales && users.find(u => u._id === rannkingDay.sales._id)">
                          <img v-if="users.find(u => u._id === rannkingDay.sales._id).avatar"
                            :src="users.find(u => u._id === rannkingDay.sales._id).avatar" alt="avatar"
                            @error="imgDefault" />
                          <img v-else src="/img/default-avatar.png" alt="avatar" />
                        </figure>
                      </div>
                    </div>
                  </div>
                  <div class="c-board-ranking__center  col-4">
                    <h3>Ranking đơn hàng ngày {{ Date.now() | moment('DD/MM/YYYY') }}</h3>
                    <p>{{ $t(rannkingDay.type) }} <span class="text-pink">{{ rannkingDay.total | numFormat }}</span> VNĐ
                    </p>
                  </div>
                  <div class="c-board-ranking__right col-4">
                    <img src="/img/run.png" alt="run" />
                  </div>
                </div>
              </div><!-- c-board-box -->
            </div><!-- col -->
          </div><!-- row -->
        </div><!-- c-board-box -->
      </div><!-- col -->
    </div><!-- row -->
  </div>
</template>

<style>
.row.is-margin-bottom {
  margin-bottom: 10px;
}
</style>

<script>
import VueApexCharts from 'vue-apexcharts';
import moment from 'moment';
import confetti from 'canvas-confetti';

export default {
  props: ["id"],
  components: { 'apexchart': VueApexCharts },
  data: function () {
    return {
      height: 300,
      service: "/top-sales",
      loading: false,
      lastMonth: moment().format('M') - 1,
      currentMonth: moment().format('M'),
      currentQuarter: moment().quarter(),
      department: null,
      sum: {},
      chart1Options: { xaxis: {}, chart: { zoom: { enabled: false }, type: 'donut' } },
      chart1Data: [],
      chart2Options: { xaxis: {}, chart: { zoom: { enabled: false }, type: 'bar' } },
      chart2Data: [],
      chart3Options: { chart: { zoom: { enabled: false }, type: 'radialBar' } },
      chart3Data: [],
      chart5Options: { xaxis: {}, chart: { zoom: { enabled: false }, type: 'bar' } },
      chart5Data: [],
      chart6Options: { xaxis: {}, chart: { zoom: { enabled: false }, type: 'bar' } },
      chart6Data: [],
      users: [],
      bestSellerLastMonth: null,
      kpis: null,
      data: [],
      rannkingDay: null,
      planOrders: []
    };
  },
  methods: {
    imgDefault(e) {
      e.target.src = '/img/default-avatar.png';
    },
    async load() {
      let resp = await this.$service.get(`${this.service}/department/${this.id}`);
      this.department = resp.data.department;
      this.department.groups = resp.data.groups;
      this.users = resp.data.users;
      this.kpis = resp.data.kpis;
      this.planOrders = resp.data.planOrders;
      this.rannkingDay = resp.data.rannkingDay;

      this.loadCurrentMonthBySales();
      this.loadCurrentMonthBySalesLastMonth();
      this.loadCurrentMonthByWeek();
      this.loadCurrentMonthByQuarter();
    },
    loadCurrentMonthByWeek() {
      let from = Number(moment(Date.now(), 'x').startOf('month').format('x'));
      let to = Number(moment(Date.now(), 'x').endOf('month').format('x'));
      this.loading = true;
      this.$service.get(`${this.service}/current`, { params: { group: "week", from: from, to: to } }).then(response => {
        let data = [];
        response.data.forEach(item => {
          item.total = item.new + item.user + item.extend + item.upgrade;
          let weekend = data.find(d => d._id === item._id.time);
          if (!weekend) {
            weekend = {
              _id: item._id.time
            };
          }

          for (let group of this.department.groups) {
            if (!group.users || !item._id.sales) {
              continue;
            }
            weekend[group.name] = weekend[group.name] || 0;
            let u = group.users.find(u => u._id === item._id.sales);
            if (u) {
              weekend[group.name] += item.total;
            }
          }

          let w = data.find(d => d._id === weekend._id);
          if (!w) {
            data.push(weekend);
          }
        });

        data.sort((a, b) => b._id - a._id);

        //Chart 2: Doanh thu theo tuần tháng 9
        this.chart2Options = {
          // title: {text: "Doanh thu theo tuần tháng " + this.currentMonth, align: 'center'},
          colors: ["#3e0079", "#fe41b2"],
          dataLabels: {
            enabled: true,
            offsetX: -6,
            style: {
              fontSize: '12px',
              colors: ['#fff']
            },
            formatter: function (value) {
              return new Intl.NumberFormat().format(value);
            }
          },
          plotOptions: {
            bar: {
              horizontal: true,
              dataLabels: {
                position: 'top',
              },
            }
          },
          yaxis: {
            tooltip: {
              enabled: false,
            }
          },
          xaxis: {
            categories: data.map(item => {
              return `${moment(Number(from) + Number(item._id), 'x').format('DD/MM')} - ${moment(Number(from) + Number(item._id), 'x').add(6, 'day').format('DD/MM')}`
            }).slice(0, 99).reverse(),
            labels: {
              formatter: function (value) {
                return new Intl.NumberFormat().format(value);
              }
            },
          },
          chart: { zoom: { enabled: false }, type: "bar" }
        };

        let chart2Data = [];
        for (let group of this.department.groups) {
          chart2Data.push({
            name: group.name,
            data: data.map(d => d[group.name]).slice(0, 99).reverse(),
          });
        }
        this.chart2Data = chart2Data;
      }).finally(() => {
        this.loading = false;
      });
    },
    loadCurrentMonthBySales() {
      let from = Number(moment(Date.now(), 'x').startOf('month').format('x'));
      let to = Number(moment(Date.now(), 'x').endOf('month').format('x'));
      this.loading = true;
      this.$service.get(`${this.service}/current`, { params: { group: "sales", from: from, to: to } }).then(response => {
        let all = response.data;
        for (let group of this.department.groups) {
          group.sum = 0;
        }
        all.forEach(item => {
          item.total = item.new + item.user + item.extend + item.upgrade;
          for (let group of this.department.groups) {
            if (!group.users) {
              continue;
            }
            group.sum = group.sum || 0;
            let u = group.users.find(u => u._id === item._id);
            if (u) {
              group.sum += item.total;
            }
          }
        });
        // Người đã nghỉ không đứng trên bảng xếp hạng nữa, nhưng doanh thu họ làm ra trong kỳ
        // vẫn phải nằm trong tổng của nhóm ở trên — nếu không thì % hoàn thành KPI của nhóm bị hụt.
        let data = this.data = all.filter(d => d.active !== false);
        data.sort((a, b) => a.total - b.total);
        // Chỉ tiêu từng người, xếp đúng thứ tự cột trên chart (cùng slice/reverse với series bên dưới)
        const targets = data.map(d => d.target || 0).slice(0, 99).reverse();

        //Chart 5: Bảng thi đua sales tháng 9
        this.chart5Options = {
          // title: {text: "Bảng thi đua sales tháng " + this.currentMonth, align: 'center'},
          colors: ["#3e0079", "#fe41b2", "#00c0e8", "#50a027"],
          dataLabels: {
            enabled: true,
            enabledOnSeries: []
          },
          plotOptions: {
            bar: {
              stacked: true,
              dataLabels: {
                total: {
                  enabled: true,
                  offsetY: -10,
                  style: {
                    fontSize: '12px',
                    fontWeight: 600,
                    color: '#000'
                  },
                  formatter: function (val, opts) {
                    const series = opts.w.globals.series;
                    const dataPointIndex = opts.dataPointIndex;
                    let total = 0;
                    for (let i = 0; i < series.length; i++) {
                      total += series[i][dataPointIndex] || 0;
                    }
                    // Mức hoàn thành theo chỉ tiêu THẬT của chính người đó trong kỳ.
                    // Trước đây chia cho 60 triệu cố định nên ai cũng bị đo bằng cùng một thước.
                    const target = (targets[dataPointIndex] || 0);
                    // Format dạng ngắn: x.xtr (triệu)
                    const formatShort = (num) => {
                      if (num >= 1000000) {
                        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'tr';
                      } else if (num >= 1000) {
                        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
                      }
                      return num.toString();
                    };
                    if (!target) {
                      return formatShort(total);
                    }
                    return `${formatShort(total)} (${(total / target * 100).toFixed(0)}%)`;
                  }
                }
              }
            }
          },
          xaxis: {
            categories: data.map(d => d.label).slice(0, 99).reverse(),
            labels: {
              rotate: -45,
            },
            tooltip: {
              enabled: false,
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return new Intl.NumberFormat().format(value);
              }
            },
          },
          // Bỏ vạch "KPI 60tr" cố định: mỗi người một chỉ tiêu khác nhau nên một đường ngang chung
          // không nói lên điều gì. Mức hoàn thành hiện thành % ngay trên đầu mỗi cột.
          chart: { zoom: { enabled: false }, type: "bar", stacked: true },
        };
        this.chart5Data = [
          {
            name: this.$t('new'),
            data: data.map(d => d.new).slice(0, 99).reverse(),
          },
          {
            name: this.$t('user'),
            data: data.map(d => d.user).slice(0, 99).reverse(),
          },
          {
            name: this.$t('extend'),
            data: data.map(d => d.extend).slice(0, 99).reverse(),
          },
          {
            name: this.$t('upgrade'),
            data: data.map(d => d.upgrade).slice(0, 99).reverse(),
          }
        ];

        //Chart 3: Mức độ hoành KPI
        let vm = this;
        this.chart3Options = {
          // title: {text: "Mức độ hoàn thành KPI " + this.currentMonth, align: 'center'},
          colors: ["#3e0079", "#00c0e8"],
          labels: this.department.groups.map(g => g.name),
          chart: { zoom: { enabled: false }, type: "radialBar" },
          legend: {
            show: true,
            floating: true,
            position: 'left',
            labels: {
              useSeriesColors: true,
            },
            markers: {
              size: 0
            },
            formatter: function (seriesName, opts) {
              let group = vm.department.groups.find(g => g.name === seriesName);
              if (group && group.kpi) {
                return `${seriesName}: ${new Intl.NumberFormat().format(group.sum / 1000000)} / ${new Intl.NumberFormat().format(group.kpi.salesTarget / 1000000)} triệu (${opts.w.globals.series[opts.seriesIndex]}%)`; //seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "%";
              }
              return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + "%";
            },
            itemMargin: {
              vertical: 3
            }
          },
          plotOptions: {
            radialBar: {
              offsetY: 0,
              startAngle: 0,
              // endAngle: 270,
              hollow: {
                margin: 5,
                size: '30%',
                background: 'transparent',
                image: undefined,
              },
            }
          },
        };

        this.chart3Data = this.department.groups.map((group) => {
          group.kpi = this.kpis.find(k => k.group === group._id);
          if (!group.kpi) {
            return 0;
          }
          return !group.sum ? 0 : Math.round(((group.sum * 100) / group.kpi.salesTarget));
        });
      }).finally(() => {
        this.loading = false;
      });

      this.$service.get(`${this.service}/current`, {
        params: {
          group: "sales",
          from: from,
          to: to,
          type: 'total'
        }
      }).then(response => {
        this.sum = {};
        let data = response.data;
        data.forEach(item => {
          item.total = item.new + item.user + item.extend + item.upgrade;
          for (let key in item) {
            if (!['label', 'clientSales', 'clientCategory', "_id", 'active', 'target'].includes(key)) {
              item[key] = Math.abs(item[key]);
              if (!this.sum[key]) {
                this.sum[key] = 0;
              }
              this.sum[key] += Math.abs(item[key]);
            }
          }
        });

        //Chart 1: Tổng doanh thu
        this.chart1Options = {
          // title: {text: "Tổng doanh thu " + this.currentMonth, align: 'center'},
          colors: ["#3e0079", "#fe41b2", "#00c0e8", "#50a027"],
          labels: [this.$t("new"), this.$t("user"), this.$t("extend"), this.$t("upgrade")],
          chart: { zoom: { enabled: false }, type: "donut" },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  total: {
                    label: new Intl.NumberFormat().format(this.sum.total / 1000000),
                    formatter: () => {
                      return "Triệu"
                    },
                    showAlways: true,
                    show: true
                  }
                }
              }
            }
          },
        };
        this.chart1Data = [this.sum.new, this.sum.user, this.sum.extend, this.sum.upgrade];
      }).finally(() => {
        this.loading = false;
      });

    },
    loadCurrentMonthBySalesLastMonth() {
      let from = Number(moment(Date.now(), 'x').subtract(1, "month").startOf('month').format('x'));
      let to = Number(moment(Date.now(), 'x').subtract(1, "month").endOf('month').format('x'));
      this.loading = true;
      this.$service.get(`${this.service}/current`, { params: { group: "sales", from: from, to: to } }).then(response => {
        this.sum = {};
        // Best seller tháng trước cũng chỉ tính người còn làm
        let data = response.data.filter(d => d.active !== false);
        data.forEach(item => {
          item.total = item.new + item.user + item.extend + item.upgrade;
        });
        data.sort((a, b) => a.total - b.total);
        if (data && data.length) {
          this.bestSellerLastMonth = data[data.length - 1];
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    loadCurrentMonthByQuarter() {
      let from = Number(moment(Date.now(), 'x').startOf('quarter').format('x'));
      let to = Number(moment(Date.now(), 'x').endOf('quarter').format('x'));
      this.loading = true;
      this.$service.get(`${this.service}/current`, { params: { group: "sales", from: from, to: to } }).then(response => {
        // Bảng quý cũng chỉ xếp hạng người còn làm, cho khớp bảng tháng ngay bên cạnh
        let data = response.data.filter(d => d.active !== false);
        data.forEach(item => {
          item.total = item.new + item.user + item.extend + item.upgrade;
        });
        data.sort((a, b) => a.total - b.total);

        //Chart 6: Bảng thi đua sales quý
        this.chart6Options = {
          // title: {text: "Bảng thi đua sales quý " + moment().quarter(), align: 'center'},
          colors: ["#3e0079", "#fe41b2", "#00c0e8", "#50a027"],
          dataLabels: {
            enabled: true,
            enabledOnSeries: []
          },
          xaxis: {
            categories: data.map(d => d.label).slice(0, 99).reverse(),
            labels: {
              rotate: -45,
            },
            tooltip: {
              enabled: false,
            }
          },
          yaxis: {
            labels: {
              formatter: function (value) {
                return new Intl.NumberFormat().format(value);
              }
            },
          },
          chart: { zoom: { enabled: false }, type: "bar", stacked: true }
        };
        this.chart6Data = [
          {
            name: this.$t('new'),
            data: data.map(d => d.new).slice(0, 99).reverse(),
          },
          {
            name: this.$t('user'),
            data: data.map(d => d.user).slice(0, 99).reverse(),
          },
          {
            name: this.$t('extend'),
            data: data.map(d => d.extend).slice(0, 99).reverse(),
          },
          {
            name: this.$t('upgrade'),
            data: data.map(d => d.upgrade).slice(0, 99).reverse(),
          }
        ];

      }).finally(() => {
        this.loading = false;
      });
    },
  },
  async mounted() {
    this.load();
    this.reloadTimerCount = setInterval(() => {
      this.load();
    }, 5 * 60 * 1000);
    document.body.style.zoom = 1 / window.devicePixelRatio;

    this.$bus.$on('creditDepositConfirmed', (data) => {
      this.$swal.fire({
        // title: `<span style="color:#2e7d32; font-size:22px; font-weight:bold;">🎉 Xác nhận nạp tiền thành công</span>`,
        html: `
      <div style="text-align:left; font-size:16px; line-height:1.6; margin-top:10px;">
        <div><b>Khách hàng:</b> <span style="color:#1565c0">${data.customer}</span></div>
        <div><b>Tên miền:</b> ${data.domain}</div>
        <div><b>Kinh doanh:</b> <span style="color:#6a1b9a">${data.sales}</span></div>
        <div style="margin-top:8px;">
          <b>Số tiền nạp:</b> 
          <span style="color:#e53935; font-weight:bold; font-size:18px;">
            ${data.amount.toLocaleString()}đ
          </span>
        </div>
      </div>
    `,
        icon: 'success',
        iconColor: '#2e7d32',
        background: 'linear-gradient(145deg, #ffffff, #f1f8e9)',
        customClass: {
          popup: 'swal-credit-popup'
        },
        showConfirmButton: false,
        toast: true,
        position: 'top-end',
        timer: 10 * 60 * 1000,
        timerProgressBar: true,
        backdrop: false
      });

      const duration = 3000;
      const end = Date.now() + duration;
      (function frame() {
        confetti({
          particleCount: 6,
          startVelocity: 40,
          spread: 360,
          ticks: 80,
          origin: {
            x: Math.random(),
            y: Math.random() - 0.2
          },
          colors: ['#4caf50', '#ffeb3b', '#ff7043', '#42a5f5']
        });
        if (Date.now() < end) requestAnimationFrame(frame);
      })();

      const flash = document.createElement('div');
      flash.className = 'flash-overlay';
      document.body.appendChild(flash);
      setTimeout(() => flash.remove(), 1200);

    });
  },
  beforeDestroy: function () {
    if (this.reloadTimerCount !== null) {
      clearInterval(this.reloadTimerCount);
    }
    this.$bus.$off('creditDepositConfirmed');
  },
  i18n: {
    messages: {
      en: {
        planOrder: 'Plan order',
        byDay: 'By day',
        byWeek: 'By week',
        byMonth: 'By month',
        byClient: 'By client',
        bySales: 'By sales',
        new: 'New',
        user: 'Buy more user',
        extend: 'Extend',
        upgrade: 'Upgrade',
        totals: 'Total',
        average: 'Average',
        selectSales: 'Select sales',
        newUser: 'New user count',
        additionalUser: 'Additional user count',
        extendedUser: 'Extended user count'
      },
      vi: {
        planOrder: 'Đơn hàng gói dịch vụ',
        byDay: 'Theo ngày',
        byWeek: 'Theo tuần',
        byMonth: 'Theo tháng',
        byClient: 'Theo client',
        bySales: 'Theo sales',
        new: 'Mua mới',
        user: 'Mua thêm',
        extend: 'Gia hạn',
        upgrade: 'Nâng cấp',
        totals: 'Tổng',
        average: 'Trung bình',
        selectSales: 'Chọn sales',
        newUser: 'Số user mới',
        additionalUser: 'Số user mua thêm',
        extendedUser: 'Số user gia hạn'
      }
    }
  }
};
</script>


<style lang="scss">
.c-rainbow-text {
  animation: rainbow 2s infinite;
  color: #4F32C1;
}

.c-image-border {
  animation: rainbow 2s infinite;
}

@keyframes rainbow {
  0% {
    color: red;
    border-color: red;
  }

  14% {
    color: orange;
    border-color: orange;
  }

  28% {
    color: yellow;
    border-color: yellow;
  }

  42% {
    color: green;
    border-color: green;
  }

  57% {
    color: blue;
    border-color: blue;
  }

  71% {
    color: indigo;
    border-color: indigo;
  }

  85% {
    color: violet;
    border-color: violet;
  }

  100% {
    color: red;
    border-color: red;
  }
}

.swal-credit-popup {
  border-radius: 18px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
}

@keyframes blink-bg {

  0%,
  100% {
    background-color: rgba(255, 255, 255, 0.6);
  }

  50% {
    background-color: rgba(255, 235, 59, 0.4);
  }
}

/* Popup glow */
.swal-credit-popup {
  box-shadow: 0 0 25px rgba(46, 125, 50, 0.6), 0 0 60px rgba(255, 235, 59, 0.4);
  animation: pulse-glow 2s infinite alternate;
  border-radius: 12px !important;
}

@keyframes pulse-glow {
  from {
    box-shadow: 0 0 20px rgba(76, 175, 80, 0.5);
  }

  to {
    box-shadow: 0 0 35px rgba(255, 235, 59, 0.7);
  }
}

/* Flash toàn màn hình */
.flash-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 0, 0.3);
  animation: flash-screen 1s ease-out;
  z-index: 9999;
}

@keyframes flash-screen {
  0% {
    opacity: 0.8;
  }

  100% {
    opacity: 0;
  }
}
</style>
